export default __webpack_public_path__ + "static/media/dog.7ee8c6bf.png";